import { Col, Row } from "antd";
import React from "react";
import styled from "styled-components";
import useModals from "../../../../../hooks/useModals";
import { Media } from "../../../../../model/Media";
import ImageModal from "../../../../../pages/UserInfo/components/ImagePreviewModal";
import { theme } from "../../../../../theme";
import ImagePreviewBox from "../../../../atoms/ImagePreviewBox";

interface Props {
  question?: string;
  answer?: string;
  questionMedias?: Media[];
}
const QnA: React.FC<Props> = ({ question, answer, questionMedias }) => {
  const { openModal } = useModals();
  return (
    <StyledWrapper>
      <StyledQuestionLine>
        <StyledPrefix>Q</StyledPrefix>
        <StyledBody>
          <Row gutter={[0, 8]}>
            <Col span={24} style={{ whiteSpace: "pre-wrap" }}>
              {question}
            </Col>
            <Col span={24}>
              <Row>
                {questionMedias?.map((val) => (
                  <Col>
                    <ImagePreviewBox
                      key={val.bufferFullUrl}
                      imgName={val.bufferFullUrl}
                      isMouseOn={false}
                      onDetail={() => {
                        openModal(
                          <ImageModal
                            image={
                              val?.bufferFullUrl ||
                              val?.largeFullUrl ||
                              val?.mediumFullUrl
                            }
                            medias={[val]}
                            folder={val.folder}
                          />
                        );
                      }}
                    />{" "}
                  </Col>
                ))}
              </Row>
            </Col>
          </Row>
        </StyledBody>
      </StyledQuestionLine>
      <StyledQnAWrapper>
        <StyledPrefix>A</StyledPrefix>
        <StyledBody className="ck-content">{answer}</StyledBody>
      </StyledQnAWrapper>
    </StyledWrapper>
  );
};

export default QnA;

const StyledQnAWrapper = styled.div`
  padding: 24px 16px;
  display: flex;
`;
const StyledWrapper = styled.div`
  display: flex;
  margin: -8px;
  justify-content: flex-start;
  flex-direction: column;
`;
const StyledPrefix = styled.div`
  ${theme.typo.heading.b14};
  display: flex;
  align-items: flex-start;
`;
const StyledBody = styled.div`
  line-height: 24px;
  margin-left: 40px;
  white-space: pre-wrap;
  word-break: break-all;
  height: 100%;
  color: ${theme.colors.gray2};
`;
const StyledQuestionLine = styled(StyledQnAWrapper)`
  box-shadow: inset 0px -1px 0px #e2e2e2;
`;
